export enum appSubscriptionFeeTypes {
  Free = 'Free',
  Standard = 'Standard',
}
